
import { mapState } from "vuex";
import restaurantOfflineOrderDialog from "../dialogs/restaurant-offline-order-dialog.vue";
import CommonToast from "./common-toast.vue";
export default {
  components: { restaurantOfflineOrderDialog, CommonToast },
  computed: {
    ...mapState("order", ["restaurantDetails", "cartLoading", "infoLoading"]),
    isLoaderOverlayVisible() {
      return this.cartLoading || this.infoLoading;
    },
    showRestaurantOfflineDialog() {
      return (
        this.restaurantDetails.whatsapp_platform?.state &&
        this.restaurantDetails.whatsapp_platform?.state !== "online"
      );
    }
  }
};
